










































































import Vue from "vue";
import Component from "vue-class-component";
import api from "@/ts/functions";
import { IFeeVueModel } from "@/ts/models/IFeeVueModel";
import builder, { IVueStateCollection } from "@/ts/FormBuilder";
import AcceptedMaterials from "@/views/permits/RockCrushing/AcceptedMaterials.vue";
import ContactEmail from "@/views/permits/RockCrushing/ContactEmail.vue";
import SiteInfo from "@/views/permits/RockCrushing/SiteInfo.vue";
import Signature from "@/views/permits/RockCrushing/Signature.vue";
import operatinghours from "@/views/permits/OperatingHours.vue";

@Component({
  components: {
    
  }
})
export default class RockCrushingRenewalReview extends Vue {
  name: string = "RockCrushingRenewalReview";
  isLoading: boolean = true;
  isReadOnly: boolean = true;
  formData: any = { volumeFee: 0, fees: [], canHaveFees: false };
  vueStates: IVueStateCollection = { formType: "", formName: "", views: [], isRenewal: false };
  header: string = "";
  formType: string = "Permits";
  formName: string = "";

  acceptedMaterials: string = "";
  dailyOperations: string = "";
  isLiquidHazardousWasteActive: boolean = false;
  isViolationsActive: boolean = false;

  appDate: string = "";

  get isFormLoaded(): boolean {
    return !this.isLoading && this.formData !== undefined;
  }

  get total(): number {
    if (this.formData.fees.length > 0) {
      let value = 0;
      (this.formData.fees as IFeeVueModel[]).forEach(fee => value = value + fee.amount);
      return value;
    }
    return 0;
  }

  created(): void {
    this.formName = this.$route.params.formName;

    this.vueStates = builder.getViewStates(this.formType, this.formName, this.$props.isRenewal);
    this.header = builder.getFormHeader(this.formName);
  }

  mounted(): void {
    api.getForm('Permits','RockCrushingRenewal', this.$route.params.applicationNumber)
        .then(result => this.formData = result)
        .finally(() => {
          this.setAppDate();
          this.$swal({
            title: "Please review your application information.",
            html: "If you need to make any changes click 'Revise' below.<br /> <br /> You must print the following summary page if you desire a receipt for your records. <br/><br />If you are ready to proceed click 'Checkout' to continue.",
            type: "info"
          }).finally(() => this.isLoading = false);
        });
  }

  private setAppDate(): void {
    let date = new Date(this.formData.applicationDate);
    this.appDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
  }

  checkout(): void {
    this.$router.push({ name: "Checkout", params: this.$route.params });
  }

  // edit(): void {
  //   this.$router.push({ name: 'RockCrushingRenewal', params: this.$route.params });
  // }

  cancel(): void {
    this.$swal({
      title: "Cancel Checkout?",
      text: "You may return at any time to complete your application.",
      type: "question",
      showCancelButton: true,
      cancelButtonText: "Stay & Continue",
      confirmButtonText: "Cancel Checkout"
    }).then(result => {
      if (result.value) {
        this.$router.push({ path: "/" });
      }
    });
  }

}
